import { useState, type JSX } from 'react';
import { Modal } from '../ui/common.js';

const REASON_CHIPS = ['업무 일정 조정 필요', '잔여 연차 부족', '대체 인력 부재', '증빙 서류 미비'];

/** 휴가 반려 사유 모달 — 사유 필수, 입력 전 "반려 처리" 비활성 */
export function RejectModal({ name, onClose, onConfirm }: {
  name: string;
  onClose: () => void;
  onConfirm: (comment: string) => Promise<void> | void;
}): JSX.Element {
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState(false);
  const valid = reason.trim().length > 0;

  const confirm = async (): Promise<void> => {
    if (!valid || busy) return;
    setBusy(true);
    try {
      await onConfirm(reason.trim());
      onClose();
    } catch {
      setBusy(false);
    }
  };

  return (
    <Modal width={440} onClose={onClose}>
      <div style={{ padding: 24 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 }}>
          <div style={{ fontSize: 17, fontWeight: 700 }}>휴가 반려</div>
          <button title="닫기" onClick={onClose} style={{ border: 'none', background: 'transparent', cursor: 'pointer', color: '#6B7280', fontSize: 26, lineHeight: 1 }}>×</button>
        </div>
        <div style={{ fontSize: 13, color: '#6B7280', marginBottom: 18 }}>
          <span style={{ fontWeight: 700, color: '#1F2937' }}>{name}</span>님의 휴가 신청을 반려합니다. 사유는 신청자에게 전달됩니다.
        </div>
        <div style={{ fontSize: 12, fontWeight: 600, color: '#6B7280', marginBottom: 7 }}>반려 사유</div>
        <div style={{ display: 'flex', gap: 7, flexWrap: 'wrap', marginBottom: 10 }}>
          {REASON_CHIPS.map((r) => {
            const on = reason === r;
            return (
              <button key={r} onClick={() => setReason(r)} style={{
                border: `1px solid ${on ? '#DC2626' : '#D1D5DB'}`, background: on ? '#FEF2F2' : '#fff',
                color: on ? '#B91C1C' : '#4B5563', fontFamily: 'inherit', fontSize: 13, fontWeight: 600,
                padding: '7px 12px', borderRadius: 7, cursor: 'pointer',
              }}>{r}</button>
            );
          })}
        </div>
        <textarea className="dx-textarea" rows={3} placeholder="반려 사유를 입력하세요" value={reason} onChange={(e) => setReason(e.target.value)} />
        <div style={{ display: 'flex', gap: 10, marginTop: 18 }}>
          <button className="dx-btn dx-btn-ghost" style={{ flex: 1 }} onClick={onClose}>취소</button>
          <button className="dx-btn dx-btn-danger" style={{ flex: 1 }} onClick={confirm} disabled={!valid || busy}>반려 처리</button>
        </div>
      </div>
    </Modal>
  );
}
